module.exports = __webpack_public_path__ + "img/solution_traffic2.ea544109.png";